<mat-card class="accion-emergencia-dialog">
  <app-card-header
    [title]="titulo"
    [subtitle]="subtitulo"
    icono="airport_shuttle"
  ></app-card-header>
  <mat-divider></mat-divider>

  @if (cargando) {
    <section class="inputs-group">
      <app-loading
        text="Cargando móviles y personal…"
        [diameter]="60"
      ></app-loading>
    </section>
  } @else {
    <form [formGroup]="form" (ngSubmit)="guardar()" autocomplete="off">
      <mat-card-content class="card-content-crear cardContentDialog">
        <!-- Resumen de la emergencia -->
        <div class="resumen-emergencia">
          <span class="em-badge" [style.--c]="prioridad.color">
            <span class="material-icons">{{ prioridad.icono }}</span>
            {{ prioridad.label }}
          </span>
          <span class="em-badge" [style.--c]="estado.color">
            <span class="material-icons">{{ estado.icono }}</span>
            {{ estado.label }}
          </span>
          <span class="resumen-dato">
            <mat-icon>person</mat-icon>
            @if (paciente) {
              {{ paciente }}
            } @else {
              <span class="no-info">Sin paciente</span>
            }
          </span>
          <span class="resumen-dato">
            <mat-icon>location_on</mat-icon>
            @if (emergencia.direccion) {
              {{ emergencia.direccion }}
            } @else {
              <span class="no-info">Sin dirección</span>
            }
          </span>
        </div>

        <!-- Móvil y chofer -->
        <app-content-card
          title="Móvil y chofer"
          icon="airport_shuttle"
          color="green"
        >
          <section class="inputs-group">
            <div class="campo-con-boton">
              <ng-select
                class="custom-ng-select"
                [items]="moviles"
                bindLabel="identificacion"
                bindValue="_id"
                placeholder="Ambulancia"
                formControlName="idMovilAsignado"
                notFoundText="No hay ambulancias"
                appendTo="body"
                (change)="onMovilChange($event)"
              >
                <ng-template ng-label-tmp let-item="item">
                  <span class="movil-opcion">
                    <span
                      class="punto"
                      [style.background]="item.colorComunicacion"
                    ></span>
                    {{ item.identificacion }}
                  </span>
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                  <div class="movil-opcion">
                    <span
                      class="punto"
                      [style.background]="item.colorComunicacion"
                    ></span>
                    <span class="movil-nombre">{{ item.identificacion }}</span>
                    @if (item.asignadaA !== undefined) {
                      <span class="movil-ocupado">
                        En la emergencia {{ item.asignadaA }}
                      </span>
                    } @else {
                      <span class="movil-libre">Disponible</span>
                    }
                    <span class="movil-detalle">
                      {{ item.textoComunicacion }}
                      @if (item.distancia !== undefined) {
                        · a {{ distanciaFormateada(item.distancia) }}
                      }
                    </span>
                  </div>
                </ng-template>
              </ng-select>
              <app-button
                matType="mat-fab"
                color="primary"
                icon="map"
                tooltip="Elegir en el mapa"
                (click)="elegirEnMapa()"
              ></app-button>
            </div>
          </section>
          @if (movilSeleccionado; as movil) {
            <section class="inputs-group">
              <div class="movil-elegido">
                <span
                  class="punto"
                  [style.background]="movil.colorComunicacion"
                ></span>
                {{ movil.textoComunicacion }}
                @if (movil.distancia !== undefined) {
                  · a {{ distanciaFormateada(movil.distancia) }} del lugar
                }
                @if (!movil.posicion) {
                  ·
                  <span class="no-info">
                    Sin posición: no se va a registrar la ubicación de partida
                  </span>
                }
              </div>
            </section>
          }
          <section class="inputs-group">
            <app-usuario-selector
              formControlName="idChofer"
              [funciones]="['Conductor']"
              placeholder="Chofer"
              [showCrearBtn]="false"
            ></app-usuario-selector>
            <ng-select
              class="custom-ng-select"
              [items]="usuariosMovil"
              bindLabel="usuario"
              bindValue="_id"
              placeholder="Usuario de la aplicación del móvil"
              formControlName="idMovilUsuario"
              notFoundText="No hay usuarios de móvil"
              appendTo="body"
            ></ng-select>
          </section>
        </app-content-card>

        <!-- Personal de salud -->
        <app-content-card
          title="Personal de salud"
          icon="medical_services"
          color="blue"
        >
          <section class="inputs-group">
            <ng-select
              class="custom-ng-select"
              [items]="medicos"
              bindLabel="nombre"
              bindValue="_id"
              placeholder="Médicos"
              formControlName="idsMedicos"
              [multiple]="true"
              [closeOnSelect]="false"
              notFoundText="No hay médicos cargados"
              appendTo="body"
            >
              <ng-template ng-option-tmp let-item="item">
                {{ item.nombre }}
                @if (item.matricula) {
                  <span class="movil-detalle">· Mat. {{ item.matricula }}</span>
                }
              </ng-template>
            </ng-select>
            <ng-select
              class="custom-ng-select"
              [items]="enfermeros"
              bindLabel="nombre"
              bindValue="_id"
              placeholder="Enfermeros"
              formControlName="idsEnfermeros"
              [multiple]="true"
              [closeOnSelect]="false"
              notFoundText="No hay enfermeros cargados"
              appendTo="body"
            ></ng-select>
          </section>
        </app-content-card>

        <!-- Destino -->
        <app-content-card title="Destino" icon="local_hospital" color="purple">
          <section class="inputs-group">
            <ng-select
              class="custom-ng-select"
              [items]="hospitales"
              bindLabel="identificacion"
              bindValue="_id"
              placeholder="Hospital"
              formControlName="idHospital"
              notFoundText="No hay hospitales cargados"
              appendTo="body"
            >
              <ng-template ng-option-tmp let-item="item">
                {{ item.identificacion }}
                @if (item.valores?.gestion) {
                  <span class="movil-detalle">
                    · {{ item.valores.gestion }}
                  </span>
                }
              </ng-template>
            </ng-select>
            <ng-select
              class="custom-ng-select"
              [items]="bases"
              bindLabel="identificacion"
              bindValue="_id"
              placeholder="Base de operaciones"
              formControlName="idCentroDeAtencion"
              notFoundText="No hay bases de operaciones cargadas"
              appendTo="body"
            ></ng-select>
          </section>
        </app-content-card>

        <!-- Observaciones -->
        <app-content-card
          [title]="reasignar ? 'Motivo y observaciones' : 'Observaciones'"
          icon="notes"
          color="orange"
        >
          @if (reasignar) {
            <section class="inputs-group">
              <mat-form-field style="width: 100%">
                <mat-icon matPrefix>edit_note</mat-icon>
                <mat-label>Motivo de la reasignación</mat-label>
                <textarea
                  matInput
                  formControlName="motivoReasignacion"
                  rows="2"
                ></textarea>
                @if (form.get('motivoReasignacion')?.hasError('required')) {
                  <mat-error>Indicá por qué se reasigna</mat-error>
                }
              </mat-form-field>
            </section>
          }
          <section class="inputs-group">
            <mat-form-field style="width: 100%">
              <mat-icon matPrefix>notes</mat-icon>
              <mat-label>Observaciones</mat-label>
              <textarea
                matInput
                formControlName="observaciones"
                rows="2"
              ></textarea>
            </mat-form-field>
          </section>
        </app-content-card>
      </mat-card-content>

      <mat-card-actions class="actions-create">
        <app-button
          matType="mat-fab extended"
          color="neutral"
          text="Cancelar"
          icon="close"
          (click)="cerrar()"
        ></app-button>
        <app-button
          matType="mat-fab extended"
          color="primary"
          [text]="reasignar ? 'Reasignar' : 'Asignar'"
          [icon]="reasignar ? 'swap_horiz' : 'assignment_ind'"
          type="submit"
          [disabled]="form.invalid || guardando"
          [loading]="guardando"
        ></app-button>
      </mat-card-actions>
    </form>
  }
</mat-card>
